'use strict';
var setSiteCookies;

setSiteCookies = require('./setSiteCookies');

Groupon.setWindowLocation = require('../../../src/frontend/helper/general/m_setWindowLocation');

module.exports = Groupon.Utils.changeUserLanguage = function(language) {
  var alternate, href, hreflang;
  setSiteCookies({
    user_locale: null
  });
  setSiteCookies({
    user_locale: language
  });
  hreflang = "[hreflang='" + language.replace('_', '-') + "']";
  if ((alternate = $("head link" + hreflang).attr("href"))) {
    href = alternate;
  } else {
    href = '/';
  }
  return Groupon.setWindowLocation(href);
};

